/* ==================================== 초기UI 실행 함수 호출  ==================================== */
function PubUI() {
  var _this = this;

  /* === script add === */
  _this.append_script = function() {
    //$("body").append( $(".jsappend-kv_script") );
  }
  _this.form_scrollbar = function() {
    var _overlayScrollbarsY = $(".js-ol_scrollbarY").overlayScrollbars({
      resize : "resize",
      autoUpdate : true,
      callbacks: {
        onScroll:function($e){
          var scrollInfo = this.scroll();
          if(scrollInfo.ratio.y === 1) {
            $( $e.target).parent().addClass("scroll-end");
          }else{
            $( $e.target).parent().removeClass("scroll-end");
          }
        }
      }
      }).overlayScrollbars();  // 스크롤 생성 
    
    var _overlayScrollbarsX = $(".js-ol_scrollbarX").overlayScrollbars({ 
      resize : "resize",
    }).overlayScrollbars();  // 스크롤 생성 
  }

  _this.form_select = function() {
    // ===== select =====

    //기본스타일 셀렉트
    $(".select2Basic").select2({  width:'100%', 
      minimumResultsForSearch: Infinity,
    });

    /* 라운드 셀렉트 */
    $(".js-select2Basic_round").select2({ width:'100%',  dropdownCssClass : 'select2_round', dropdownAutoWidth : false,  minimumResultsForSearch: Infinity,});
    $(".js-select2Basic_round_dark").select2({ width:'100%',       
    dropdownCssClass : 'select2_round theme-dark', minimumResultsForSearch: Infinity,}); 

    /* 라운드 셀렉트-pop */
    $(".js-select2Basic_round-pop").select2({ width:'100%',  dropdownCssClass : 'select2_round select2_pop', dropdownAutoWidth : false,  minimumResultsForSearch: Infinity,});
    $(".js-select2Basic_round_dark-pop").select2({ width:'100%',       
    dropdownCssClass : 'select2_round theme-dark select2_pop', minimumResultsForSearch: Infinity,}); 


    /* 투명왼쪽 셀렉트 */
    $(".js-select2Basic_noneline").select2({ width:'100%',  dropdownCssClass : 'select2_noneline', dropdownAutoWidth : false,  minimumResultsForSearch: Infinity,});
    $(".js-select2Basic_noneline_dark").select2({ width:'100%',       
    dropdownCssClass : 'select2_noneline theme-dark', minimumResultsForSearch: Infinity,}); 

    /* 모서리 라운딩 셀렉트 */
    var select2Basic_edge_white = $(".js-select2Basic_edge_theme-light").select2({ width:'100%', 
      dropdownCssClass : 'select2_edge theme-light select-scroll',
      dropdownAutoWidth : false,  
      minimumResultsForSearch: Infinity,});
    var select2Basic_edge_dack  = $(".js-select2Basic_edge_theme-dark").select2({ width:'100%',       
      dropdownCssClass : 'select2_edge theme-dark select-scroll', 
      dropdownAutoWidth : false,
      minimumResultsForSearch: Infinity,}); 

    /* 모서리 라운딩 라인 셀렉트 */      
    $(".js-select2Basic_edgeline").select2({ width:'100%',  dropdownCssClass : 'select2_edgeline', dropdownAutoWidth : false,  minimumResultsForSearch: Infinity,});

  }

  _this.form_input_del = function() {
    function inputdel_fn($this) {
      ///console.log('$this.val()', $this.val());
      var _noneDisable = !$this.prop("disabled");
      if( $this.val() != "" && _noneDisable){
          $this.siblings("button").css({display:"block"});
          $this.siblings("button").one("click", function(){
              $this.val("");
              $this.siblings("button").css({display:"none"});
          });
      }else{
          $this.siblings("button").css({display:"none"});
      }
    }
    $("body").on("focusout", ".input_del input", function(){
      inputdel_fn( $(this) );
    });
    $("body .input_del input").each(function($i){
        inputdel_fn( $(this) );
    });
  }


  
}

/* ==================================== 초기실행 함수 호출  ==================================== */
var _szPC  = 1320;   
var _szMB  = 959;   // 960 
/* 호출 */
function responsiveDevices(){ 
    var _change_width = window.innerWidth; //  $(window).innerWidth(); //
    var _temp_width;  
    //console.log(_change_width)
    if(_change_width > _szMB){
      _temp_width = "is_pc";
    }else {
      _temp_width = "is_mb";
    };
    if (!$('body').hasClass(_temp_width)) {
      $("body").removeClass("is_pc is_mb");
      $("body").addClass(_temp_width);
      console.log("===============responsiveDevices=====================")
    }
    $("body").attr( "data-device" , _temp_width);
    return _temp_width
}





/**
 * trpRgbToHex : rgb => hex
 * @param   {string} $rgbType : rgb(255, 64, 0) 	
 * 
*/
function trpRgbToHex( $rgbType ){ 
	var rgb = $rgbType.replace( /[^%,.\d]/g, "" ).split( "," ); 
	rgb.forEach(function (str, x, arr){ 
			/* 컬러값이 "%"일 경우, 변환하기. */ 
			if ( str.indexOf( "%" ) > -1 ) str = Math.round( parseFloat(str) * 2.55 ); 
			/* 16진수 문자로 변환하기. */ 
			str = parseInt( str, 10 ).toString( 16 ); 
			if ( str.length === 1 ) str = "0" + str; 
			arr[ x ] = str; 
	}); 
	return "#" + rgb.join( "" ); 
} 

/**
* trpRgbToHex : hex => rgb : 
* @param   {string} $hexType : 	#aa4400
* 
*/
function trpHexToRgb( $hexType ){ 
	var hex = $hexType.trim().replace( "#", "" ); 
	var rgb = ( 3 === hex.length ) ? 
	hex.match( /[a-f\d]/gi ) : hex.match( /[a-f\d]{2}/gi );
	
	rgb.forEach(function (str, x, arr){     
			if ( str.length == 1 ) str = str + str; 
			arr[ x ] = parseInt( str, 16 ); 
	}); 
	//return "rgb(" + rgb.join(", ") + ")"; 
	return  rgb.join(", "); 
} 